export default {
      id: "bouee-usage",
      viewBox: "0 0 115 80",
      url: "../dist/images/" + "sprite.svg#bouee-usage",
      toString: function () {
        return this.url;
      }
    }